export function localStorageSupported() {
    let testStorage;
    try {
        window.localStorage.setItem('testKey', '1');
        window.localStorage.removeItem('testKey');
        testStorage = true;
    } catch (e) {
        testStorage = false;
    }
    return 'localStorage' in window && window.localStorage !== null && testStorage;
}

const supported = localStorageSupported();

export function getKey(key) {
    if (supported) {
        return window.localStorage.getItem(key);
    }
    return null;
}

export function getObject(key) {
    const value = getKey(key);
    return value === '' ? null : JSON.parse(value);
}

export function setKey(key, value) {
    if (supported) {
        window.localStorage.setItem(key, value);
    }
}

export function setObject(key, valueObject) {
    setKey(key, JSON.stringify(valueObject));
}

export function removeKey(key) {
    if (supported) {
        window.localStorage.removeItem(key);
    }
}
